import { useHistory } from "react-router-dom";

import {
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  IonButton,
  IonRow
} from '@ionic/react';
import ExploreContainer from '../components/ExploreContainer';
import './Impostazioni.css';





const Impostazioni: React.FC = () => {
  var history = useHistory();
  return (
    <IonPage  >

      <ExploreContainer name="Home page" />
      <IonHeader style={{ height: "6%" }}>
        <IonToolbar  class={'toolback'} style={{ height: "100%", paddingTop: "10px" }}>
          <IonTitle class={'background-content'} style={{ fontSize: "30px" }}>Impostazioni</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent class={'background-content'} fullscreen >
      {/* f7.views.current.router.navigate('/DefinizioneImpianto/')  */}
        <IonRow style={{ height: "15%",justifyContent:"center",marginTop:"25%" }}>
          <IonButton onClick={() => { history.push("/DefinizioneImpianto")}}  size="large" style={{width:"314px",height:"80px",fontSize:"30px",fontFamily:"Bahnschrift" }} class={"bottImpostazioniColor"} >Definizione Impianto</IonButton>
        </IonRow>
       
       <IonRow style={{ height: "15%",justifyContent:"center" }}>
          <IonButton onClick={() => {history.push("/Menu") }} size="large" style={{width:"314px",height:"80px",fontSize:"30px",fontFamily:"Bahnschrift" }}class={"bottImpostazioniColor"}>Definizione Menù</IonButton>
      </IonRow>
        
        <IonRow style={{ height: "15%", justifyContent:"center"}}>
          <IonButton onClick={() => {history.push("/Preset") }} size="large" style={{width:"314px",height:"80px",fontSize:"30px",fontFamily:"Bahnschrift" }}class={"bottImpostazioniColor"} >Preset</IonButton>
        </IonRow>
     </IonContent>
    </IonPage>
  );
};

export default Impostazioni;
